import React from 'react';
import { JOB_STATES_ORDER, STATUS_LABELS } from '@/lib/format';
import { Calendar, Navigation, Play, CheckCheck, Receipt, CreditCard } from 'lucide-react';

const ICONS = {
  scheduled: Calendar,
  on_my_way: Navigation,
  in_progress: Play,
  finished: CheckCheck,
  invoiced: Receipt,
  paid: CreditCard,
};

export function JobStateTimeline({ status = 'scheduled', history = [] }) {
  const idx = JOB_STATES_ORDER.indexOf(status);
  const cancelled = status === 'cancelled';
  const historyMap = {};
  (history || []).forEach(h => { historyMap[h.to] = h.at; });

  return (
    <div className="w-full">
      <div className="flex items-center gap-1 overflow-x-auto md:overflow-visible py-2">
        {JOB_STATES_ORDER.map((s, i) => {
          const isDone = !cancelled && i < idx;
          const isCurrent = !cancelled && i === idx;
          const Icon = ICONS[s];
          return (
            <React.Fragment key={s}>
              <div className="flex flex-col items-center min-w-[64px] md:min-w-0" data-testid={`timeline-node-${s}`}>
                <div className={`flex h-8 w-8 items-center justify-center rounded-full border-2 ${
                  isCurrent ? 'border-primary bg-primary text-primary-foreground' :
                  isDone ? 'border-[hsl(var(--fc-success))] bg-[hsl(var(--fc-success))] text-white' :
                  'border-border bg-muted text-muted-foreground'
                }`}>
                  <Icon className="h-4 w-4" />
                </div>
                <div className={`mt-1 text-[10px] md:text-xs whitespace-nowrap ${isCurrent ? 'font-semibold' : 'text-muted-foreground'}`}>
                  {STATUS_LABELS[s]}
                </div>
              </div>
              {i < JOB_STATES_ORDER.length - 1 && (
                <div className={`h-px flex-1 min-w-[8px] ${i < idx && !cancelled ? 'bg-[hsl(var(--fc-success))]' : 'bg-border'}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
      {cancelled && (
        <div className="mt-2 rounded-md border border-border bg-muted px-3 py-2 text-sm text-muted-foreground">This job was cancelled.</div>
      )}
    </div>
  );
}
